export var LogMessageType;
(function (LogMessageType) {
    LogMessageType["INFO"] = "INFO";
    LogMessageType["ERROR"] = "ERROR";
    LogMessageType["WARNING"] = "WARNING";
    LogMessageType["CRITICAL"] = "CRITICAL";
})(LogMessageType || (LogMessageType = {}));
